import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BmxShowDirective} from './bmx-show.directive';
import { SwipeDirective } from './swipe.directive';


@NgModule({
	declarations: [
		BmxShowDirective,
  SwipeDirective
	],
	exports: [
		BmxShowDirective,
		SwipeDirective
	],
	imports: [
		CommonModule
	]
})
export class DirectiveModule { }
